<template>
<div class="popup" v-cloak v-if="iosPayTipShow">
    <div class="content" id="iosPayTip">
        <div class="title">
                {{$t('language.popup.iosPayTipPopup.title')}}
            <div class="icon white-close dialog-close" @click="iosPayTipShow=false"></div>
        </div>
        <div class="ios-tip-body">
            <div class="ios-tip-mid">
                <div class="ios-tip-tips">{{$t('language.popup.iosPayTipPopup.tip',{"name":payInfo.name,"id":payInfo.appleId})}}</div>
            </div>
            <div class="ios-tip-close">
                <button class="white-btn" @click="unsubscribePlan()">{{$t('language.popup.iosPayTipPopup.btnTxt')}}</button>
                <button @click="iosPayTipShow=false">{{$t('language.common.ok')}}</button>
            </div>
        </div>

    </div>

</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import getCurrencyUtils from '@/js/workspace/get_currency.js';
export default {
    data() {
        return {
            iosPayTipShow: false,
            user: commonUtils.getUser(),
            payInfo: {
                name: "",
                appleId: "",
            },
        }
    },
    methods: {
        //取消订阅
        unsubscribePlan() {
            window.open("https://support.apple.com/en-us/HT202039");
        },
    }
}
</script>

<style>
#iosPayTip {
    width: 600px;
    /*no*/
    height: 210px;
    /*no*/
}

.ios-tip-body{
    padding: 20Px;
    display: grid;
}

.ios-tip-msg{
    display: flex;
    margin-bottom: 10Px;
}

.ios-tip-msg-left{
    width: 60%;
    float: left;
    display: grid;
}

.ios-tip-msg-right{
    width: 40%;
    float: right;
    display: grid;
    text-align: right;
    padding-right: 20Px;
}

.ios-tip-name{
    color: #333333;
    font-size: 16Px;
    font-weight: 700;
    line-height: 20Px;
}

.ios-tip-tip{
    color: #6f6f6f;
    font-size: 14Px;
    line-height: 22Px;
}

.ios-tip-price{
    line-height: 33Px;
}

.ios-tip-price .price{
    font-size: 30Px;
    color: #5562b4;
}

.ios-tip-price .old-price{
    color: #b8bee6;
    position: unset;
    float: unset;
}

.ios-tip-vat{
    font-size: 14Px;
    color: #a3adbd;
    line-height: 20Px;
}

.ios-tip-mid {
    display: grid;
    line-height: 22Px;
    font-size: 14Px;
    margin: 10Px 0;
}

.ios-tip-mid .ios-tip-tips{
    color: #333333;
}

.ios-tip-mid .ios-tip-click span{
    color: #5562b4;
    cursor: pointer;
}

.ios-tip-mid .ios-tip-click span:hover{
    text-decoration: underline;
}

.ios-tip-close{
    position: absolute;
    bottom: 20Px;
    right: 20Px;
}

.ios-tip-close .white-btn{
    border: 1Px solid #7080c6;
    background: #fff;
    color: #7080c6;
}

.ios-tip-close button{
    min-width: 110Px;
    height: 30Px;
    background: linear-gradient(to right,#6576df, #8580e7);
    border-radius: 5Px;
    margin-left: 20Px;
}

#iosPayTip .title{
    background: linear-gradient(to right,#6576df, #8480da);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/pay_system_popups/ios_pay_tip_popups.vue